import { render } from "./page-404.vue?vue&type=template&id=508e647e&scoped=true"
import script from "./page-404.vue?vue&type=script&lang=js"
export * from "./page-404.vue?vue&type=script&lang=js"

import "./page-404.vue?vue&type=style&index=0&id=508e647e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508e647e"]])

export default __exports__